import React from 'react';
import {
    IconButton,
    Portal,
    Menu,
    MenuButton,
    MenuList,
    MenuItem
} from '@chakra-ui/react';
import {
    RiMore2Fill
} from 'react-icons/ri';

const IconDropdown = ({ items = [], data = null }) => {
    return (
        <Menu>
            <MenuButton
                as={IconButton}
                icon={<RiMore2Fill />}
                variant="outline"
                size="sm"
            />
            <Portal>
                <MenuList>
                    {
                        items.map(({ label , icon ,handleClick, action , color, disabled }, index)=>(
                            <MenuItem disabled={ disabled} key={data?._id + index} color={color || 'gray.500'} onClick={()=> handleClick(data)} icon={icon}>{label}</MenuItem>
                        ))
                    }
                </MenuList>
            </Portal>
        </Menu>
    );
};

export default IconDropdown;
